import { useEffect, useState } from 'react'

import { RequestStandardSharing } from 'src/types'

export function calcRestPercentage(
  request_standard_sharings: RequestStandardSharing[]
) {
  return (
    100 -
    request_standard_sharings
      .filter(item => item.active)
      .reduce(
        (accumulator: number, { percentage }: { percentage: number }) =>
          accumulator + percentage,
        0
      )
  )
}

function useCalcRestPercentage(
  request_standard_sharings: RequestStandardSharing[]
) {
  const [restPercentage, setRestPercentage] = useState<number>(100)

  useEffect(() => {
    setRestPercentage(calcRestPercentage(request_standard_sharings))
  }, [request_standard_sharings])

  return restPercentage
}

export default useCalcRestPercentage
